import { render, staticRenderFns } from "./SetupContries.vue?vue&type=template&id=ca36020a"
import script from "./SetupContries.vue?vue&type=script&lang=js"
export * from "./SetupContries.vue?vue&type=script&lang=js"
import style0 from "./SetupContries.vue?vue&type=style&index=0&id=ca36020a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports